import { createRootRoute, Outlet } from '@tanstack/react-router'
import { UpgradeModal } from '../components/billing/UpgradeModal'
import { NotFoundPage } from '../components/common/NotFoundPage'
import { ConsentBar } from '../components/consent/ConsentBar'

export const Route = createRootRoute({
  component: () => (
    <>
      <Outlet />
      <UpgradeModal />
      <ConsentBar />
    </>
  ),
  notFoundComponent: NotFoundPage,
})
